import { render, staticRenderFns } from "./manage-editor.vue?vue&type=template&id=b769ec4e"
import script from "./manage-editor.vue?vue&type=script&lang=js"
export * from "./manage-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports